export default "__VITE_ASSET__DJICjJKu__"